/**
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
export default class NumberFomrat {
  static commaSeparated(value) {
    return value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : value
  }
}
